// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"95":"f2c400c9","636":"841147f7","747":"a1480346"}[chunkId] + ".js";
};